'use client';

import { sendGTMEvent } from '@next/third-parties/google';

export type GTMPayload = Record<string, any>;

/**
 * Pushes data to dataLayer (Consent Mode handled by Efilli/Google).
 * - Safe on client (no-op on server)
 * - Uses the Next helper as the single dispatch path
 */
export const dataLayerPush = (data: GTMPayload): void => {
  try {
    if (typeof window === 'undefined') return;

    sendGTMEvent(data);
  } catch (error) {
    console.log('GTM error:', error);
  }
};
